import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  exportButton: {
    color: '#387285 !important',
    border: '#387285 solid 1px !important',
    marginTop: 15,
    marginLeft: 15,
  },
}))
